import { Effect, Reducer } from 'umi';
import { getPrivileges } from '@dbl/services/global';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const namespace = 'privilegesConfig';

interface PrivilegesConfigStateType {
  allPrivileges: string[];
  isPermissionAdmin : boolean;
  isPermissionManager: boolean;
  privilegesLoading: boolean;
}


interface PrivilegesConfigType {
  namespace: string;
  state: PrivilegesConfigStateType;
  effects: {
    getPrivilegesConfig: Effect;
  };
  reducers: {
    save: Reducer<PrivilegesConfigStateType>;
  };
}

const PrivilegesConfig: PrivilegesConfigType = {
  namespace,
  state: {
    allPrivileges: [],
    isPermissionAdmin: false,
    isPermissionManager: false,
    privilegesLoading: false,
  },
  reducers: {
    save(state: PrivilegesConfigStateType, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  effects: {
    *getPrivilegesConfig(action, {put}) {
      try {
        yield put({
          type: "save",
          payload: {
            privilegesLoading: true,
          }
        });
        const config: Record<string, {privilege: string;}[]> = yield getPrivileges(action.payload);
        const privileges: string[] = [];
        config?.main_game?.forEach(game => privileges.push(game.privilege));
        config?.common_game?.forEach(game => privileges.push(`common_${game.privilege}`));
        // 细粒度的按钮显示
        // add_dashboard==>是否可以新增报表按钮
        // add_chart==>是否可以新增图表按钮
        // edit_dataset=>不是公共业务
        // edit_common_dataset=>公共业务
        // add_model==>是否可以新增模型按钮
        // test_model==>是否可以测试模型按钮
        // publish_model==>是否可以发布模型按钮
        privileges.push(
          config.add_dashboard && 'add_dashboard',
          config.add_chart && 'add_chart',
          config.edit_dataset && 'edit_dataset',
          config.edit_common_dataset && 'edit_common_dataset',
          config.add_model && 'add_model',
          config.test_model && 'test_model',
          config.publish_model && 'publish_model',
        );
        yield put({
          type: "save",
          payload: {
            allPrivileges: privileges?.filter(Boolean),
            // sys_admin：系统管理员（如 AI 公共模板、报表公共模板）
            isPermissionAdmin: config?.permission?.role_name === 'sys_admin',
            // game_manager：业务管理员（如 AI 游戏模板、报表游戏模板）
            isPermissionManager: config?.permission?.role_name === 'game_manager',
            privilegesLoading: false,
          }
        });
      } catch (e) {
        yield put({
          type: "save",
          payload: {
            allPrivileges: [],
            isPermissionAdmin: false,
            isPermissionManager: false,
            privilegesLoading: false,
          }
        });
      }
    },
  }
};

export default PrivilegesConfig;